import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

// Animation for popup
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

// Main Assistino button container
export const AssistinoButtonContainer = styled.div(({ theme, locale }) => ({
  position: 'fixed',
  bottom: '40px',
  right: locale === 'ar' ? 'auto' : '20px',
  left: locale === 'ar' ? '20px' : 'auto',
  zIndex: 1000,
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  transform: 'scale(1)',
  borderRadius: '50%',
  overflow: 'visible',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  width: '60px',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#ffffff',
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
    '& $AssistinoPopup': {
      opacity: 1,
      visibility: 'visible',
      transform: 'translateY(0)',
    },
    '& $AssistinoImage': {
      transform:
        locale === 'ar' ? 'scaleX(-1) rotate(-10deg)' : 'rotate(10deg)',
    },
  },
}))

// Popup tooltip that appears on hover
export const AssistinoPopup = styled.div(({ theme, locale }) => ({
  position: 'absolute',
  bottom: '70px',
  right: locale === 'ar' ? 'auto' : '0',
  left: locale === 'ar' ? '0' : 'auto',
  backgroundColor: theme.ateneoBlue || '#1a237e',
  color: 'white',
  padding: '12px 16px',
  borderRadius: '8px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  fontSize: '14px',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  opacity: 0,
  visibility: 'hidden',
  transform: 'translateY(10px)',
  transition: 'all 0.3s ease 0.1s',
  animation: `${fadeIn} 0.3s ease-out`,
  zIndex: 1001,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-6px',
    right: locale === 'ar' ? 'auto' : '20px',
    left: locale === 'ar' ? '20px' : 'auto',
    width: '12px',
    height: '12px',
    backgroundColor: theme.ateneoBlue || '#1a237e',
    transform: 'rotate(45deg)',
  },
  ':dir(rtl)': {
    right: 'auto',
    left: '0',
    '&::after': {
      right: 'auto',
      left: '20px',
    },
  },
}))

// AI icon image
export const AssistinoImage = styled.img(({ theme, locale }) => ({
  width: '40px',
  height: '40px',
  objectFit: 'contain',
  transition: 'transform 0.3s ease',
  transform: locale === 'ar' ? 'scaleX(-1)' : 'none', // Flip image for Arabic/RTL
  ':dir(rtl)': {
    transform: 'scaleX(-1)',
  },
}))

// Optional: Add a pulse animation for attention
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(26, 35, 126, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(26, 35, 126, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(26, 35, 126, 0);
  }
`

export const AssistinoButtonPulse = styled.div(({ theme }) => ({
  position: 'absolute',
  top: '-5px',
  left: '-5px',
  right: '-5px',
  bottom: '-5px',
  borderRadius: '50%',
  animation: `${pulse} 2s infinite`,
  pointerEvents: 'none',
  zIndex: -1,
}))

// Container for the entire Assistino button with popup
export const AssistinoButtonWrapper = styled.div(({ theme, locale }) => ({
  position: 'relative',
  display: 'inline-block',
}))
